<template>
	<div class="custom-header">
		<div class="back-box" v-show="show_back" @click="goBack">
			<div class="account-name">&lt; 返回</div>
		</div>
		<div class="header-wrap">
			<router-link to="/" v-if="setting">
				<img class="logo" :src="setting.logo || '../assets/images/home/logo.png'" />
			</router-link>
			<div v-show="show_login" class="account-box" @click="goLogin">
				<img src="../assets/images/home/user@2x.png" />
				<div class="account-name" v-if="!is_login">账号登录</div>
				<div class="account-name" v-if="is_login && userInfo">{{ userInfo.nickname }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';

	export default {
		name: "Header",
		props: {
			show_back: {
				type: Boolean,
				default: false,
			},
			show_login: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
			}
		},
		computed: {
			...mapState(['userInfo', "setting"]),
			is_login() {
				return this.$store.state.is_login
			}
		},

		methods: {
			goBack() {
				this.$router.back();
			},
			goLogin() {

				if (!this.$store.getters.isLoginDynamic()) {
					this.$store.commit('update_login_state', false)
					this.$router.push({
						path: "/login",
					});
					return
				}
				this.$router.replace({
					path: "/user/center",
				});

			},
		},
		mounted() {

		}
	};
</script>

<style scoped lang="scss">
	.custom-header {
		height: 80px;
		width: 100%;
		background: #222222;
		display: flex;
		align-items: center;
		position: relative;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #ffffff;
		line-height: 20px;
		.back-box {
			position: absolute;
			left: 43px;
			top: 22px;
			display: flex;
			align-items: center;
			line-height: 22px;
			height: 22px;
			color: #edd4ac;
			cursor: pointer;
			img {
				width: 8px;
				height: 14px;
				margin-right: 10px;
			}
		}
		.header-wrap {
			position: relative;
			width: 1170px;
			height: 100%;
			margin: 0 auto;
			.logo {
				display: block;
				width: 230px;
				height: 37px;
				margin: 25px auto 25px;
			}

			.account-box {
				position: absolute;
				right: 0;
				top: 29px;
				display: flex;
				align-items: center;
				cursor: pointer;

				img {
					width: 16px;
					height: 18px;
					margin-right: 10px;
				}
			}
		}
	}
</style>
